import { IonText } from '@ionic/react';
import { ReactElement } from 'react';
import i18n from '../../../i18n';

const ScratchpadPlaylistGettingStarted = (): ReactElement => {
  return (
    <div className="full-height-width content-center">
      <IonText className="ion-padding ion-text-center" color="medium">
        <h2>{i18n.t('common:scratchpad_playlist_get_started')}</h2>
      </IonText>
    </div>
  );
};

export { ScratchpadPlaylistGettingStarted };
